/* @flow */

import {
  convertSupportSentToNotification,
  convertSupportSentErrorToNotification,
} from 'src/shared/app/support/util/supportUtils';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';

export function showSupportSentNotification() {
  return queueNotification(convertSupportSentToNotification());
}

export function showSupportSentErrorNotification() {
  return queueNotification(convertSupportSentErrorToNotification());
}
